/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — length, weight, volume and the other categories measure different physical quantities, so there's no valid conversion factor between them (a meter has no fixed relationship to a kilogram). Each category on this page only converts within itself, between units that measure the same kind of quantity.`)
};

const es_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — longitud, peso, volumen y otras categorías miden cantidades físicas diferentes, así que no hay un factor de conversión válido entre ellas (un metro no tiene una relación fija con un kilogramo). Cada categoría en esta página solo convierte dentro de sí, entre unidades que miden el mismo tipo de cantidad.`)
};

const de_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — Länge, Gewicht, Volumen und die anderen Kategorien messen unterschiedliche physikalische Größen, daher gibt es keinen gültigen Umrechnungsfaktor zwischen ihnen (ein Meter steht in keinem festen Verhältnis zu einem Kilogramm). Jede Kategorie auf dieser Seite rechnet nur innerhalb sich selbst um, zwischen Einheiten, die dieselbe Art von Größe messen.`)
};

const nl_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — lengte, gewicht, volume en de andere categorieën meten verschillende fysische hoeveelheden, dus er is geen geldige conversiefactor tussen hen (een meter heeft geen vaste relatie tot een kilogram). Elke categorie op deze pagina converteert alleen binnen zichzelf, tussen eenheden die dezelfde soort hoeveelheid meten.`)
};

const fr_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — la longueur, le poids, le volume et les autres catégories mesurent des quantités physiques différentes, donc il n'y a pas de facteur de conversion valide entre eux (un mètre n'a pas de relation fixe avec un kilogramme). Chaque catégorie sur cette page convertit uniquement en elle-même, entre les unités qui mesurent le même type de quantité.`)
};

const it_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — lunghezza, peso, volume e altre categorie misurano quantità fisiche diverse, quindi non esiste un fattore di conversione valido tra loro (un metro non ha una relazione fissa con un chilogrammo). Ogni categoria su questa pagina converte solo all'interno di se stessa, tra unità che misurano lo stesso tipo di quantità.`)
};

const pt_br2_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — comprimento, peso, volume e as outras categorias medem quantidades físicas diferentes, portanto não há fator de conversão válido entre elas (um metro não tem relacionamento fixo com um quilograma). Cada categoria nesta página converte apenas dentro de si mesma, entre unidades que medem o mesmo tipo de quantidade.`)
};

const pt_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — comprimento, peso, volume e as outras categorias medem quantidades físicas diferentes, portanto não existe um factor de conversão válido entre elas (um metro não tem relação fixa com um quilograma). Cada categoria nesta página apenas converte dentro de si mesma, entre unidades que medem o mesmo tipo de quantidade.`)
};

const ja_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ — 長さ、質量、体積およびその他のカテゴリは異なる物理量を測定しているため、それらの間に有効な変換係数はありません(メートルはキログラムとの固定関係を持ちません)。このページの各カテゴリは、同じ種類の量を測定する単位間でのみ自身内で変換します。`)
};

const zh_uc_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq4_a", locale)
	if (locale === "en") return en_uc_hub_faq4_a(inputs)
	if (locale === "es") return es_uc_hub_faq4_a(inputs)
	if (locale === "de") return de_uc_hub_faq4_a(inputs)
	if (locale === "nl") return nl_uc_hub_faq4_a(inputs)
	if (locale === "fr") return fr_uc_hub_faq4_a(inputs)
	if (locale === "it") return it_uc_hub_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq4_a(inputs)
	if (locale === "pt") return pt_uc_hub_faq4_a(inputs)
	if (locale === "ja") return ja_uc_hub_faq4_a(inputs)
	return zh_uc_hub_faq4_a(inputs)
};